(function() {
  class $7410600c3327e07e$var$CustomSelect extends HTMLElement {
    constructor() {
      super();
      this.trigger = null;
      this.nativeSelect = null;
      this.dropdown = null;
      this.underlay = null;
      this.closeButtons = [];
      this.options = [];
      this.isOpen = false;
      this.focusIndex = -1;
      this._uniqueId = "";
    }
    connectedCallback() {
      this.trigger = this.querySelector("[data-select-trigger]");
      this.nativeSelect = this.querySelector("[data-native-select]");
      this.dropdown = this.querySelector("[data-dropdown]");
      this.underlay = this.querySelector("[data-underlay]");
      this.closeButtons = this.querySelectorAll("[data-close]");
      this.options = Array.from(this.querySelectorAll("[data-option]"));
      if (!this.trigger || !this.nativeSelect || !this.dropdown) return;
      this._uniqueId = this.dataset.id || "select-default";
      this.initAccessibility();
      this.attachEventListeners();
      this.updateSelectedState(this.nativeSelect.value);
    }
    initAccessibility() {
      this.trigger.setAttribute("role", "combobox");
      this.trigger.setAttribute("aria-expanded", "false");
      this.trigger.setAttribute("aria-controls", `${this._uniqueId}-list`);
      this.trigger.setAttribute("aria-haspopup", "listbox");
      this.trigger.id = `${this._uniqueId}-button`;
      this.dropdown.id = `${this._uniqueId}-list`;
      this.dropdown.setAttribute("role", "listbox");
      this.dropdown.setAttribute("aria-labelledby", `${this._uniqueId}-button`);
      this.options.forEach((option, index) => {
        option.id = `${this._uniqueId}-opt-${index}`;
        option.setAttribute("role", "option");
        const isSelected = option.dataset.value === this.nativeSelect.value;
        option.setAttribute("aria-selected", isSelected);
      });
    }
    attachEventListeners() {
      this.trigger.addEventListener("click", e => {
        e.preventDefault();
        this.toggleDropdown();
      });
      this.trigger.addEventListener("keydown", e => this.handleKeyDown(e));
      this.options.forEach((option, index) => {
        option.addEventListener("click", e => {
          e.stopPropagation();
          this.selectOption(option, index);
        });
      });
      if (this.underlay) this.underlay.addEventListener("click", () => this.closeDropdown());
      this.closeButtons.forEach(btn => {
        btn.addEventListener("click", () => this.closeDropdown());
      });
      this.handleOutsideClick = e => {
        if (this.isOpen && !this.contains(e.target)) this.closeDropdown();
      };
      document.addEventListener("click", this.handleOutsideClick);
      this.nativeSelect.addEventListener("change", () => {
        this.updateSelectedState(this.nativeSelect.value);
      });
    }
    handleKeyDown(e) {
      switch (e.key) {
       case "Enter":
       case " ":
        e.preventDefault();
        if (this.isOpen) {
          if (this.focusIndex >= 0) this.selectOption(this.options[this.focusIndex], this.focusIndex);
        } else this.openDropdown();
        break;

       case "Escape":
        if (this.isOpen) {
          e.preventDefault();
          this.closeDropdown();
        }
        break;

       case "ArrowDown":
        e.preventDefault();
        this.navigateOptions(1);
        break;

       case "ArrowUp":
        e.preventDefault();
        this.navigateOptions(-1);
        break;

       case "Home":
        e.preventDefault();
        this.focusIndex = 0;
        this.navigateOptions(0);
        break;

       case "End":
        e.preventDefault();
        this.focusIndex = this.options.length - 1;
        this.navigateOptions(0);
        break;
      }
    }
    navigateOptions(direction) {
      if (!this.isOpen) this.openDropdown();
      this.focusIndex += direction;
      if (this.focusIndex < 0) this.focusIndex = 0;
      if (this.focusIndex >= this.options.length) this.focusIndex = this.options.length - 1;
      this.updateVisualFocus();
      const focusedOption = this.options[this.focusIndex];
      if (focusedOption) focusedOption.scrollIntoView({
        block: "nearest"
      });
    }
    updateVisualFocus() {
      this.options.forEach((opt, index) => {
        const indicator = opt.querySelector("[data-indicator]");
        const isSelected = opt.dataset.selected === "true";
        const isFocused = index === this.focusIndex;
        if (indicator) {
          if (isSelected || isFocused) indicator.classList.add("outline-1", "outline-solid", "outline-scheme-text"); else indicator.classList.remove("outline-1", "outline-solid", "outline-scheme-text");
        }
        if (isFocused) this.trigger.setAttribute("aria-activedescendant", opt.id);
      });
    }
    toggleDropdown() {
      this.isOpen ? this.closeDropdown() : this.openDropdown();
    }
    openDropdown() {
      this.isOpen = true;
      this.dropdown.classList.remove("hidden");
      this.setAttribute("data-is-open", "true");
      this.trigger.setAttribute("aria-expanded", "true");
      this.trigger.classList.add("text-scheme-links");
      if (this.underlay) {
        this.underlay.classList.add("opacity-100", "pointer-events-auto");
        this.underlay.classList.remove("opacity-0", "pointer-events-none");
      }
      this.#toggleBodyClasses(true);
      if (window.matchMedia("(max-width: 1024px)").matches) document.documentElement.classList.add("sort-open");
      const selectedValue = this.nativeSelect.value;
      this.focusIndex = this.options.findIndex(opt => opt.dataset.value === selectedValue);
      if (this.focusIndex === -1) this.focusIndex = 0;
      this.updateVisualFocus();
      const arrow = this.trigger.querySelector("svg");
      if (arrow) arrow.classList.add("rotate-180");
    }
    #toggleBodyClasses(isOpening) {
      if (!this.hasAttribute("data-scroll-lock")) return;
      const lockCondition = this.getAttribute("data-scroll-lock");
      const isTablet = window.matchMedia("(max-width: 1024px)").matches;
      if (lockCondition === "tablet" && !isTablet) return;
      if (isOpening) document.documentElement.classList.add("overflow-clip", "overflow-hidden"); else document.documentElement.classList.remove("overflow-clip", "overflow-hidden");
    }
    closeDropdown() {
      this.isOpen = false;
      this.dropdown.classList.add("hidden");
      this.removeAttribute("data-is-open");
      this.trigger.setAttribute("aria-expanded", "false");
      this.trigger.removeAttribute("aria-activedescendant");
      this.trigger.classList.remove("text-scheme-links");
      if (this.underlay) {
        this.underlay.classList.remove("opacity-100", "pointer-events-auto");
        this.underlay.classList.add("opacity-0", "pointer-events-none");
      }
      this.#toggleBodyClasses(false);
      document.documentElement.classList.remove("sort-open");
      const arrow = this.trigger.querySelector("svg");
      if (arrow) arrow.classList.remove("rotate-180");
      this.trigger.focus();
    }
    selectOption(option, index) {
      const value = option.dataset.value;
      this.nativeSelect.value = value;
      this.nativeSelect.dispatchEvent(new Event("input", {
        bubbles: true,
        cancelable: true
      }));
      this.nativeSelect.dispatchEvent(new Event("change", {
        bubbles: true,
        cancelable: true
      }));
      this.updateSelectedState(value);
      this.closeDropdown();
    }
    updateSelectedState(selectedValue) {
      this.options.forEach(opt => {
        const isSelected = opt.dataset.value === selectedValue;
        const indicator = opt.querySelector("[data-indicator]");
        opt.dataset.selected = isSelected;
        opt.setAttribute("aria-selected", isSelected);
        if (indicator) {
          if (isSelected) indicator.classList.add("bg-scheme-links"); else indicator.classList.remove("bg-scheme-links");
        }
      });
    }
    disconnectedCallback() {
      document.removeEventListener("click", this.handleOutsideClick);
    }
  }
  if (!customElements.get("custom-select")) customElements.define("custom-select", $7410600c3327e07e$var$CustomSelect);
})();